import React, { useEffect, useState, useContext } from "react";
import { useParams } from 'react-router-dom'
import "../css/project_page.css";
import { getTimestamp30DaysAgo, getTimestampToday } from "../helpers/date_conversion"
import { ProjectDashboard } from "./Overview";
import { getStuff, postStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { authenticatedContext, userDataContext } from "../App";
import { ButtonWIcon, CloseButton, TextInput, TextArea, MyDatePicker } from './Inputs'
import Table from "./Table";
import { useNavigate } from "react-router-dom";
import { convertTimestampToCzech, dateObjToStrDate } from "../helpers/date_conversion";
import { ExportContext } from './Layout'

export default function ProjectPage() {
  const { id } = useParams()
  const [navIndex, setNavIndex] = React.useState(0);
  const addAlertBanner = useContext(AlertsContext);
  const { authenticated, setAuthenticated } = useContext(authenticatedContext);

  const [projectData, setProjectData] = useState(null)
  const [editProjectOpen, setEditProjectOpen] = useState(false);

  function handleEditProjectPress() {
    setEditProjectOpen(!editProjectOpen);
  };

  const emptyAidRecords = {
    for_period: [getTimestamp30DaysAgo(), getTimestampToday()],
    aid_records: []
  }

  useEffect(() => {
    getStuff(`project/${id}/analysis/`).then((res) => {
      if (res.status === 200) {
        let project_data = res.data
        project_data.aid_records = emptyAidRecords
        setProjectData(project_data);

      } else if (res.status == 400) {
        addAlertBanner(res.data.error, "danger");
      }
      else if (res.status === 401) {
        setAuthenticated(false);
      } else {
        console.log("error", res)
        addAlertBanner("Něco se pokazilo", "danger");
      }
    });
  }, [])

  if (projectData == null) return "";
  const projectInfo = editProjectOpen ? <EditProject projectData={projectData} editToggle={handleEditProjectPress} setProjectData={setProjectData} /> : <ProjectOverview projectData={projectData} editToggle={handleEditProjectPress} />
  return (
    <>
      <div className="project-overview">
        <div className="project-title">
          Projekt: <span className="project-subtitle">{projectData.name}</span>
        </div>
        <div className="project-details">
          <div className="project-nav">
            <div className="nav-items">
              <div className={`nav-item ${navIndex === 0 ? 'active' : ''}`} onClick={() => { setNavIndex(0) }} >Přehled</div>
              <div className={`nav-item ${navIndex === 1 ? 'active' : ''}`} onClick={() => { setNavIndex(1) }} >Klienti projektu</div>
              <div className={`nav-item ${navIndex === 2 ? 'active' : ''}`} onClick={() => { setNavIndex(2) }} >Podpora v rámci projektu</div>
            </div>
          </div>
          <div className="content-conatainer">
            {navIndex === 0 && projectInfo}
            {navIndex === 1 && <ProjectClients project_id={id} />}
            {navIndex === 2 && <ProjectAidRecords project_id={id} />}

          </div>
        </div>
      </div>

    </>
  );
}


function ProjectOverview({ projectData, editToggle }) {

  const addAlertBanner = useContext(AlertsContext);
  const { authenticated, setAuthenticated } = useContext(authenticatedContext);

  return (
    <div className="project-info">
      <div className="info-header">
        <div className="info-title">Údaje o projektu</div>
        <ButtonWIcon iconSrc={"/img/svg/edit.svg"} onClick={editToggle} />
      </div>
      <table className="info-table">
        <tbody>
          <tr>
            <td className="info-label">PLNÝ NÁZEV</td>
            <td className="info-value">{projectData.name}</td>
          </tr>
          <tr>
            <td className="info-label">
              ZKRÁCENÝ NÁZEV{" "}
              <span className="info-label-note">(max 6 znaků)</span>
            </td>
            <td className="info-value">{projectData.short_name}</td>
          </tr>
          <tr>
            <td className="info-label">POPIS</td>
            <td className="info-description">{projectData.description}</td>
          </tr>
          <tr>
            <td className="info-label">DATUM ZALOŽENÍ</td>
            <td className="info-value">{convertTimestampToCzech(projectData.project_start)}</td>
          </tr>
          <tr>
            <td className="info-label">DATUM KONCE</td>
            <td className="info-value">{convertTimestampToCzech(projectData.project_end)}</td>
          </tr>
        </tbody>
      </table>
      <ProjectDashboard p_data={projectData} showTitle={false} />
    </div>
  )
}

export function EditProject({ projectData, editToggle, setProjectData }) {
  console.log("projectd ", projectData)
  const [name, setName] = useState(projectData.name);
  const [shortName, setShortName] = useState(projectData.short_name);
  const [description, setDescription] = useState(projectData.description);
  const [projectStart, setProjectStart] = useState(projectData.project_start);
  const [projectEnd, setProjectEnd] = useState(projectData.project_end);

  const [showSave, setShowSave] = useState(false);
  const addAlertBanner = useContext(AlertsContext);

  useEffect(() => {
    if (name !== projectData.name || shortName !== projectData.short_name || description !== projectData.description || projectStart !== projectData.project_start || projectEnd !== projectData.project_end) {
      setShowSave(true)
    } else {
      setShowSave(false)
    }

  }, [name, shortName, description, projectStart, projectEnd])

  function validateMyInputs() {
    if (name.trim() === "") {
      addAlertBanner("Plný název je povinný", "warning");
      return false;
    }
    if (shortName.trim() === "") {
      addAlertBanner("Zkrácený název je povinný", "warning");
      return false;
    }
    if (!projectStart) {
      addAlertBanner("Datum založení je povinné", "warning");
      return false;
    }
    if (projectEnd && projectEnd < projectStart) {
      addAlertBanner("Datum konce nemůže být před datem založení", "warning");
      return false;
    }
    if (shortName.length > 6) {
      addAlertBanner("Zkrácený název nemůže být delší než 6 znaků", "warning");
      return false;
    }
    return true;
  }

  function handleSave() {
    if (!validateMyInputs()) {
      return;
    }

    const data = {
      project_id: projectData.project_id,
      name: name !== projectData.name && name,
      short_name: shortName !== projectData.short_name && shortName,
      description: description !== projectData.description && description,
      project_start: projectStart !== projectData.project_start && projectStart,
      project_end: projectEnd != projectData.project_end && projectEnd,
    };

    postStuff("project/update/", data).then((res) => {
      try {
        if (res.status === 200) {
          addAlertBanner("Změny uloženy", "success");
          let old_data = projectData
          old_data.name = name
          old_data.short_name = shortName
          old_data.description = description
          old_data.project_end = projectEnd
          old_data.project_start = projectStart
          setProjectData(old_data)
          editToggle();
        } else if (res.status === 400) {
          addAlertBanner("Chyba! " + res.data.error, "warning");
        } else if (res.status == 403) {
          addAlertBanner("Nemáte dostatečné oprávnění", "warning");
        } else {
          addAlertBanner("Něco se pokazilo", "danger");
        }
      } catch (error) {
        addAlertBanner("Něco se pokazilo", "danger");
      }
    });
  }


  return (
    <div className="edit-proj">
      <div className="project-info">
        <div className="info-header">
          <div className="info-title">Editace projektu</div>
          <CloseButton onClick={editToggle} />
        </div>
        <table className="info-table">
          <tbody>
            <tr>
              <td className="info-label">PLNÝ NÁZEV</td>
              <td className="info-value">
                <TextInput value={name} setValue={setName} />
              </td>
            </tr>
            <tr>
              <td className="info-label">
                ZKRÁCENÝ NÁZEV{" "}
                <span className="info-label-note">(max 6 znaků)</span>
              </td>
              <td className="info-value">
                <TextInput value={shortName} setValue={setShortName} />
              </td>
            </tr>
            <tr>
              <td className="info-label">POPIS</td>
              <td className="info-description">
                <TextArea value={description} setValue={setDescription} />
              </td>
            </tr>
            <tr>
              <td className="info-label">DATUM ZALOŽENÍ</td>
              <td className="info-value">
                <MyDatePicker value={projectStart} setValue={setProjectStart} />
              </td>
            </tr>
            <tr>
              <td className="info-label">DATUM KONCE</td>
              <td className="info-value">
                <MyDatePicker value={projectEnd} setValue={setProjectEnd} />
              </td>
            </tr>
          </tbody>
        </table>

        {showSave && <ButtonWIcon
          iconSrc={"/img/svg/save.svg"}
          onClick={handleSave}
          style={{ backgroundColor: "#68E965" }}
          text={"Uložit"} />
        }
      </div>
    </div>
  )
}

function ProjectClients({ project_id }) {
  const { authenticated, setAuthenticated } = useContext(authenticatedContext);
  const { userData, setUserData } = useContext(userDataContext);

  const [firstName, setFirstName] = useState("");
  const [firstNameSort, setFirstNameSort] = useState(0);
  const [lastName, setLastName] = useState("");
  const [lastNameSort, setLastNameSort] = useState(0);
  const [birthDateSort, setBirthDateSort] = useState(0);
  const [cardNumber, setCardNumber] = useState("");
  const [tagList, setTagList] = useState([]);
  const [reqUrl, setReqUrl] = useState("");
  const navigate = useNavigate();




  useEffect(() => {
    setReqUrl(`/clients/filter/${firstName || "null"}/${firstNameSort}/${lastName || "null"}/${lastNameSort}/${birthDateSort}/${cardNumber || "null"}/${tagList.join(",") || "null"}/${project_id}`);
  }, [firstName, firstNameSort, lastName, lastNameSort, birthDateSort, cardNumber, tagList])
  return (
    <div className="clients">
      <Table
        reqUrl={reqUrl}
        headers={[
          {
            name: "Jméno",
            dataKey: "first_name",
            search: {
              value: firstName,
              setValue: setFirstName
            },
            sort: {
              value: firstNameSort,
              setValue: setFirstNameSort
            },
            type: "text",
          },
          {
            name: "Příjmení",
            dataKey: "last_name",
            search: {
              value: lastName,
              setValue: setLastName
            },
            sort: {
              value: lastNameSort,
              setValue: setLastNameSort
            },
            type: "text",
          },
          {
            name: "Datum narození",
            dataKey: "birth_date",
            search: false,
            sort: {
              value: birthDateSort,
              setValue: setBirthDateSort
            },
            type: "text",
          },
          {
            name: "Číslo karty",
            dataKey: "card_number",
            search: {
              value: cardNumber,
              setValue: setCardNumber
            },
            sort: false,
            type: "text",
          },
          {
            name: "Štítky",
            dataKey: "tags",
            search: {
              value: tagList,
              setValue: setTagList
            },
            sort: false,
            category_options_data_key: "availible_tags",
            type: "category",
          },
        ]}
        actions={{
          displayButtons: true,
          edit: true,
          view: true,
          delete: true,
          requestBase: "/client/",
          recordIdKey: "client_id"
        }}

      />
    </div>
  );
}


function ProjectAidRecords({ project_id }) {
  const [reqUrl, setReqUrl] = useState("");

  const [firstName, setFirstName] = useState("");
  const [firstNameSort, setFirstNameSort] = useState(0);
  const [lastName, setLastName] = useState("");
  const [lastNameSort, setLastNameSort] = useState(0);
  const [timeSort, setTimeSort] = useState(0);
  const exportFile = useContext(ExportContext);
  const [timeRange, setTimeRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  useEffect(() => {
    const start_d = timeRange[0].startDate ? dateObjToStrDate(timeRange[0].startDate) : "null"
    const end_d = timeRange[0].endDate ? dateObjToStrDate(timeRange[0].endDate) : "null"
    setReqUrl(`/aid_records/${firstName || "null"}/${firstNameSort}/${lastName || "null"}/${lastNameSort}/${start_d}/${end_d}/${timeSort}/${project_id}`);

  }, [firstName, firstNameSort, lastName, lastNameSort, timeRange, timeSort]);

  function exportAid(){
    exportFile("export/project/aid_records/" + project_id, 'Export_zaznamu_pomoci.csv')
  }


  return (
    <div className="aid-records">
      <div className="heading-controls">
        <h3>Vaši Klienti</h3>
        <div className="head-controls">
          <ButtonWIcon iconSrc={"/img/svg/export.svg"} onClick={exportAid} text={"Exportovat"}/>
        </div>
      </div>
      <Table
        reqUrl={reqUrl}
        redirectOnRecordClick={false}

        headers={[
          {
            name: "Jméno",
            dataKey: "first_name",
            search: {
              value: firstName,
              setValue: setFirstName
            },
            sort: {
              value: firstNameSort,
              setValue: setFirstNameSort
            },
            type: "text",
          },
          {
            name: "Příjmení",
            dataKey: "last_name",
            search: {
              value: lastName,
              setValue: setLastName
            },
            sort: {
              value: lastNameSort,
              setValue: setLastNameSort
            },
            type: "text",
          },
          {
            name: "Čas",
            dataKey: "ts",
            search: {
              value: timeRange,
              setValue: setTimeRange,
              datePickerOpen: datePickerOpen,
              setDatePickerOpen: setDatePickerOpen
            },
            sort: {
              value: timeSort,
              setValue: setTimeSort
            },
            type: "time",
          }
        ]}

      />
    </div>
  );
}